import { render } from "./ClubOutlayRow.vue?vue&type=template&id=285985d0"
import script from "./ClubOutlayRow.vue?vue&type=script&lang=js"
export * from "./ClubOutlayRow.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__